export const SET_POINTS_DATA = 'POINTS_MANAGER_SET_DATA'
export const RESET_POINTS_DATA = 'POINTS_MANAGER_RESET_DATA'

export const setPointsData = (data) => {
  return { type: SET_POINTS_DATA, data: data }
}
export const resetPointsData = () => {
  return { type: RESET_POINTS_DATA }
}
